export default __webpack_public_path__ + "static/media/area-templates.15df3adf.svg";